import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// Logical area: UserSessionVerifier General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.UserSessionVerifier.';

  public static readonly userLoggedOff = `${Id.prefix}userLoggedOff`;
  public static readonly userSwitched = `${Id.prefix}userSwitched`;
}

export class LangUserSessionVerifier {
  private constructor() {}

  public static userLoggedOff(): string {
    return interpolate(Id.userLoggedOff);
  }
  public static userSwitched(): string {
    return interpolate(Id.userSwitched);
  }
}

export class UserSessionVerifierModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(
      Id.userLoggedOff,
      'This session must be reloaded because you have logged off in another session.',
      'Session reload message for logoff'
    );
    register.add(
      Id.userSwitched,
      'This session must be reloaded because you have switched to a different user in another Tab.',
      'Session reload message for user switch'
    );
  }
}
